import { CommonConnector } from '@getvim/extension-connector';
import { Infra } from '@getvim/vim-connect';
import { LOGIN_WIDGET_NAME } from '@getvim/vim-connect/src/infra/common/consts';

export const handlePublish = (payload: any, event: string) =>
  CommonConnector.sendDataToWidget({ widgetId: LOGIN_WIDGET_NAME, payload: { event, payload } });
